module.exports = __webpack_public_path__ + "img/publication-gray.62d97b38.svg";